import React from 'react';

const Video = ({ruta,size }) => (
    <video
        className={size}
        controls="0"
        poster="/img/lp-300/poster.jpg"
        controlsList="nodownload"
        playsInline
    >
        <source
            src={ruta}
            type="video/mp4"
        />
    </video>
)

export default Video;




